export const ENV_CONFIG = () => {
  return {
    CLOUDINARY: {
      LANDING: 'https://res.cloudinary.com/drbtttdox/image/upload/v1745948249',
      LANDING_VIDEO: 'https://res.cloudinary.com/drbtttdox/video/upload/v1745948249',
      BIO_1:
        'https://res.cloudinary.com/drbtttdox/image/upload/f_auto,q_auto,w_1600/v1790082531/bio_1_nvdkh1.jpg',
      TALLER:
        'https://res.cloudinary.com/drbtttdox/image/upload/f_auto,q_auto,w_1600/v1790085565/taller_fg1wjr.jpg',
      CLOUD_NAME: 'drbtttdox',
      UPLOAD_PRESET: 'fyustman_upload',
    },
  };
};
